module.exports = __webpack_public_path__ + "img/icon2.3d65f6b2.png";